import React, { useState } from 'react';
import styles from './AcademicYearsTab.module.scss';
import AddYear from '../add-year/AddYear';
import DeletePopup from '../../../Molecules/Custom/DeletePopup';
import Settings from '../settings/Settings';

const AcademicYearsTab = ({
  years = [],
  activeYearId,
  onSelect,
  onAddYear,
  onDeleteYear,
  isDeleting,
  refetchAcademicYears,
  onSetDefaultYear,
  isSettingDefault,
}) => {
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [item, setItem] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [yearToDelete, setYearToDelete] = useState(null);

  const openDeleteModal = (e, year) => {
    e.stopPropagation();
    // if (year.isDefault) return;
    setYearToDelete(year);
    setIsDeleteOpen(true);
  };

  const closeDeleteModal = () => {
    if (isDeleting) return;
    setIsDeleteOpen(false);
    setYearToDelete(null);
  };
  const confirmDelete = (year) => {
    if (!yearToDelete?.id) return;

    onDeleteYear(yearToDelete, () => setIsDeleteOpen(false));
  };

  const onEdit = (item) => {
    setItem(item);
    setIsAddOpen(true);
  };
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>السنوات الأكاديمية</p>
        <div className={styles.headerActions}>
          <AddYear
            isAddOpen={isAddOpen}
            onClose={() => (setIsAddOpen(false), setItem(null))}
            onSave={(data) => onAddYear?.(data)}
            onSuccess={() => (
              refetchAcademicYears(), setIsAddOpen(false), setItem(null)
            )}
            item={item}
          />{' '}
          <Settings
            years={years}
            onSetDefaultYear={onSetDefaultYear}
            isLoading={!!isSettingDefault}
            onSuccess={refetchAcademicYears}
          />
        </div>
      </div>

      <ul className={styles.list}>
        {years.map((year) => (
          <li
            key={year.id}
            className={`${styles.item} ${
              year.id === activeYearId ? styles.active : ''
            }`}
            onClick={() => onSelect?.(year)}
          >
            <p className={styles.count}>({' ' + year.count + ' '})</p>
            <p className={styles.label}>{year.label}</p>
            {year.isDefault && <img src='/icons/star.svg' alt='' />}
            <button
              type='button'
              className={styles['edit-container']}
              onClick={() => onEdit(year)}
            >
              <img src='/icons/edit.svg' alt='' />
            </button>

            <button
              type='button'
              className={styles['delete-container']}
              onClick={(e) => openDeleteModal(e, year)}
            >
              <img
                src='/icons/delete.svg'
                alt=''
                className={styles['delete']}
              />
            </button>
          </li>
        ))}
      </ul>

      {isDeleteOpen && (
        <DeletePopup
          handleOnClose={closeDeleteModal}
          title='السنة الدراسية'
          handleDelete={confirmDelete}
          isLoading={!!isDeleting}
          selectedItem={yearToDelete}
        />
      )}
    </div>
  );
};

export default AcademicYearsTab;
